import FormNewChanges from "../../base/actions/FormNewChanges";

const formNewChanges: FormNewChanges = {
    changeRequestFinishedTitle: "Anforderung zum Ändern {type} abgeschlossen.",
    updatedFromPlcTitle: "Die Werte von {type} wurden direkt an der SPS-Einheit geändert.",
    dialogMessage: "Möchten Sie die aktuellen Werte laden?",
}

export default formNewChanges;